module.exports = __webpack_public_path__ + "static/media/wsp.bd4d95ff.jpg";